import {database} from "../config";


export function getRecipesAsList(cb) {
  database.collection("recipes").onSnapshot((querySnapshot) => {
    let newRecipes = [];
    querySnapshot.forEach(function (doc) {
      let data = doc.data();
      if (data.hide) {
        return;
      }
      if (!data.isk) data.isk = 0;
      if (!data.materials) data.materials = {};
      if (!data.blueprint_price) data.blueprint_price = data.blueprintPrice;
      newRecipes.push(data);
    });
    cb(newRecipes);
  });
}

export const STATUS_QUEUED = "queued";
export const STATUS_CLAIMED = "claimed";
export const STATUS_BUILT = "built";
export const STATUS_DELIVERED = "delivered";
export const STATUS_DELIVERING = "delivering";
export const STATUS_CANCELED = "canceled";

export function getMaterialsMap(cb) {
  database.collection("materials").onSnapshot((querySnapshot) => {
    let newMaterials = {};
    querySnapshot.forEach(function (doc) {
      newMaterials[doc.data().name] = doc.data();
    });
    cb(newMaterials)
  });
}

export function getUser(userID, cb) {
  database.collection("users").doc(userID).onSnapshot(doc => {
    cb(doc.data());
  });
}